import { Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getPlanzoneSettings(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ settings }) => settings);
}

export { getPlanzoneSettings };
